"use strict";

var React           = require("react");
var Router          = require("react-router");
var Link = Router.Link;

var Header = React.createClass({
    checkScroll: function(element) {
        this.props.checkScroll(element);
    },
    render: function () {
        return (
            <header>
                <div className="intro-text">
                    <div className="intro-lead-in">
                        <p>Vertu viss hvað þú átt</p>
                    </div>
                    <div className="intro-heading">
                        <p>Búnaðarbankinn</p>
                    </div>
                    <div className="intro-more-info">
                        <span className="intro-more-info-text" onClick={this.checkScroll.bind(this, "moreInfo")} ref="moreInfo">Fræðast nánar</span>
                        <span className="glyphicon glyphicon-arrow-down"></span>
                    </div>
                </div>
            </header>
        );
    }
});

module.exports = Header;



// WEBPACK FOOTER //
// ./app/scripts/ui/Frontpage/Header.react.js